/**
 * useDecisionNode - Decision node specific operations
 */
import { DEFAULT_STATUSES } from '../../FlowchartView/TaskNode/constants';
import { findPreferredStatus } from '../../FlowchartView/utils/statusUtils';

export const useDecisionNode = (localSprint, setLocalSprint, recordAction) => {

  const handleDecisionAnswerChange = (taskId, answer) => {
    const task = localSprint?.tasks?.find(t => t.id === taskId);
    const oldAnswer = task?.answer;
    const oldStatus = task?.status;
    const oldCompletedAt = task?.completedAt;
    const oldStartedAt = task?.startedAt;

    setLocalSprint(prev => {
      if (!prev) return prev;
      const tasks = prev.tasks || [];
      const statuses = prev.statuses || DEFAULT_STATUSES;
      
      const preferredCompleted = findPreferredStatus(statuses, 'completed');
      const completedStatusId = preferredCompleted?.id || 'completed';
      
      const preferredNotStarted = findPreferredStatus(statuses, 'not_started');
      const notStartedStatusId = preferredNotStarted?.id || 'pending';
      
      return {
        ...prev,
        tasks: tasks.map(t => {
          if (t.id !== taskId) return t;
          
          if (answer) {
            // Decision made - set to completed status
            return { 
              ...t, 
              answer,
              status: completedStatusId,
              completedAt: new Date().toISOString(),
            };
          } else {
            // Decision cleared - revert to not started status
            return { 
              ...t, 
              answer,
              status: notStartedStatusId,
              completedAt: null,
              startedAt: null,
            };
          }
        }),
      };
    });

    // Record for undo
    if (recordAction) {
      recordAction({
        type: 'CHANGE_DECISION_ANSWER',
        undo: () => {
          setLocalSprint(prev => {
            if (!prev) return prev;
            return {
              ...prev,
              tasks: prev.tasks.map(t => 
                t.id === taskId 
                  ? { ...t, answer: oldAnswer, status: oldStatus, completedAt: oldCompletedAt, startedAt: oldStartedAt }
                  : t
              ),
            };
          });
        },
        redo: () => handleDecisionAnswerChange(taskId, answer),
      });
    }
  };

  const handleDecisionOptionsChange = (taskId, options) => {
    const task = localSprint?.tasks?.find(t => t.id === taskId);
    const oldOptions = task?.options;

    setLocalSprint(prev => {
      if (!prev) return prev;
      const tasks = prev.tasks || [];
      return {
        ...prev,
        tasks: tasks.map(t => 
          t.id === taskId ? { ...t, options } : t
        ),
      };
    });

    // Record for undo
    if (recordAction) {
      recordAction({
        type: 'CHANGE_DECISION_OPTIONS',
        undo: () => {
          setLocalSprint(prev => {
            if (!prev) return prev;
            return {
              ...prev,
              tasks: prev.tasks.map(t => t.id === taskId ? { ...t, options: oldOptions } : t),
            };
          });
        },
        redo: () => {
          setLocalSprint(prev => {
            if (!prev) return prev;
            return {
              ...prev,
              tasks: prev.tasks.map(t => t.id === taskId ? { ...t, options } : t),
            };
          });
        },
      });
    }
  };

  return {
    handleDecisionAnswerChange,
    handleDecisionOptionsChange,
  };
};

export default useDecisionNode;

